import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

interface EstructuraInput {
  type: string;
  title: string;
  maxlength?: number;
  required?: boolean;
  placeholder?: string;
  accept?: string;
  maxSize?: string;
  min?: number | string;
  max?: number | string;
  rows?: number;
  options?: Array<{ value: string; label: string }>;
}

interface AnexoCargoBackend {
  id: number;
  cargo_id: number;
  input_id: number;
  estructura_input: string; // Viene como string JSON del backend
  created_at: string;
  updated_at: string;
  aspirante_cargo?: {
    id: number;
    nombre: string;
    descripcion: string;
    created_at: string;
    updated_at: string;
  };
}

interface AnexoCargoParsed {
  id: number;
  cargo_id: number;
  input_id: number;
  estructura_input: EstructuraInput;
  created_at: string;
  updated_at: string;
  aspirante_cargo?: {
    id: number;
    nombre: string;
    descripcion: string;
    created_at: string;
    updated_at: string;
  };
}

@Component({
  selector: 'app-structure-reading',
  templateUrl: './structure-reading.component.html',
  styleUrls: ['./structure-reading.component.css']
})
export class StructureReadingComponent implements OnInit {

  @Input() anexosData: AnexoCargoBackend[] = [];

  @Output() deleteAnexoEvent = new EventEmitter<AnexoCargoBackend>();

  // Lista de anexos parseados
  anexosParsed: AnexoCargoParsed[] = [];

  // Tipos de inputs disponibles para iconos y etiquetas
  tiposInput = [
    { value: 'input-text', label: 'Texto', icon: 'fa-font' },
    { value: 'textarea', label: 'Área de texto', icon: 'fa-align-left' },
    { value: 'number', label: 'Número', icon: 'fa-hashtag' },
    { value: 'email', label: 'Email', icon: 'fa-envelope' },
    { value: 'tel', label: 'Teléfono', icon: 'fa-phone' },
    { value: 'date', label: 'Fecha', icon: 'fa-calendar' },
    { value: 'file', label: 'Archivo', icon: 'fa-file-upload' },
    { value: 'select', label: 'Selector', icon: 'fa-list' },
    { value: 'checkbox', label: 'Casillas múltiples', icon: 'fa-check-square' },
    { value: 'radio', label: 'Opción única', icon: 'fa-dot-circle' }
  ];

  constructor() { }

  ngOnInit() {
    this.parsearAnexos();
  }

  ngOnChanges() {
    this.parsearAnexos();
  }

  // ==================== MÉTODOS PRINCIPALES ====================

  parsearAnexos() {
    if (!this.anexosData || !Array.isArray(this.anexosData)) {
      this.anexosParsed = [];
      return;
    }

    this.anexosParsed = this.anexosData.map(anexo => {
      try {
        const estructuraParsed = JSON.parse(anexo.estructura_input);
        return {
          ...anexo,
          estructura_input: estructuraParsed
        };
      } catch (error) {
        console.error('Error al parsear estructura_input:', error);
        return {
          ...anexo,
          estructura_input: {
            type: 'unknown',
            title: 'Error al cargar',
            required: false
          }
        };
      }
    });

    // Ordenar por input_id
    this.anexosParsed.sort((a, b) => a.input_id - b.input_id);
  }

  // ==================== MÉTODOS AUXILIARES ====================

  obtenerIconoTipo(type: string): string {
    const tipo = this.tiposInput.find(t => t.value === type);
    return tipo ? tipo.icon : 'fa-question';
  }

  obtenerNombreTipo(type: string): string {
    const tipo = this.tiposInput.find(t => t.value === type);
    return tipo ? tipo.label : type;
  }

  tieneOpciones(estructura: EstructuraInput): boolean {
    return estructura.options && estructura.options.length > 0;
  }

  obtenerTextoOpciones(estructura: EstructuraInput): string {
    if (!estructura.options || estructura.options.length === 0) {
      return '';
    }
    return estructura.options.map(opt => opt.label).join(', ');
  }

  obtenerRangoFechas(estructura: EstructuraInput): string {
    if (!estructura.min && !estructura.max) {
      return 'Sin restricción';
    }
    const min = estructura.min || 'Sin mínimo';
    const max = estructura.max || 'Sin máximo';
    return `${min} - ${max}`;
  }

  obtenerRangoNumeros(estructura: EstructuraInput): string {
    if (estructura.min === undefined && estructura.max === undefined) {
      return 'Sin restricción';
    }
    const min = estructura.min !== undefined ? estructura.min : 'Sin mínimo';
    const max = estructura.max !== undefined ? estructura.max : 'Sin máximo';
    return `${min} - ${max}`;
  }

  formatearFecha(fecha: string): string {
    if (!fecha) return '';
    try {
      const date = new Date(fecha);
      return date.toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch (error) {
      return fecha;
    }
  }

  deleteAnexo(anexo: AnexoCargoBackend) {
    this.deleteAnexoEvent.emit(anexo);
  }
}